import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReportWidget from './ReportWidget';
import FlickityWidget from './FlickityWidget';
import Chart from '../../util/chart';
import { convertToArrayOfObjects } from '../../util/report';

class WEBRO2Widget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      averagePayTotal: 0,
      openAverageDays: 0,
      lastLaborAverageDays: 0,
      totalCost: 0,
      openROsByPPC: [],
      statusTotals: [],
    };

    this.handleData = this.handleData.bind(this);
  }

  handleData({ data, cols }) {
    const newState = {
      lastLaborAverageDays: 0,
      openAverageDays: 0,
      totalCost: 0,
      openROsByPPC: [],
      statusTotals: [],
    };

    // transform array of positional data to array of json objects
    data = convertToArrayOfObjects(data, cols);

    const { codes } = this.props;

    const ppcStats = {};
    const statusStats = {};
    data.forEach((row) => {
      newState.lastLaborAverageDays += parseInt(row.elapsedDays);
      newState.totalCost += parseFloat(row.totalCost);
      newState.openAverageDays += parseInt(row.openDays);

      if (!ppcStats[row.ppc]) {
        ppcStats[row.ppc] = { count: 0 };
      }
      ppcStats[row.ppc].count++;

      if (!statusStats[row.status]) {
        statusStats[row.status] = { count: 0, totalCost: 0, estimatedCost: 0 };
      }

      statusStats[row.status].count++;
      statusStats[row.status].totalCost += parseFloat(row.totalCost);
      statusStats[row.status].estimatedCost += parseFloat(row.estimatedCost);
    });

    newState.averagePayTotal = newState.totalCost / data.length;
    newState.openAverageDays /= data.length;
    newState.lastLaborAverageDays /= data.length;

    const statusCounts = Object.keys(statusStats).sort((a, b) => {
      return statusStats[b].count - statusStats[a].count;
    });

    for (const status of statusCounts) {
      const code = codes.find(c => c.id === parseInt(status));
      const label = code ? code.name : status || 'Unassigned';

      newState.statusTotals.push({
        label,
        count: statusStats[status].count.toLocaleString(),
        totalCost: statusStats[status].totalCost.toLocaleString(),
        estimatedCost: statusStats[status].estimatedCost.toLocaleString(),
      });
    }

    const mostOpenByPPC = Object.keys(ppcStats).sort((a, b) => {
      return ppcStats[b].count - ppcStats[a].count;
    });

    for (let i = 0; i < (Math.min(mostOpenByPPC.length, 10)); i++) {
      newState.openROsByPPC.push({
        label: mostOpenByPPC[i],
        value: ppcStats[mostOpenByPPC[i]].count,
      });
    }

    this.setState({ ...newState, openROs: data.length }, () => this.renderCharts());
  }

  renderCharts() {
    const { openROsByPPC, statusTotals } = this.state;

    Chart.makePieChart('webro2-widget-chart-1', {
      titles: [{
        text: `Open ROs by PPC (Top ${openROsByPPC.length})`,
      }],
      dataProvider: openROsByPPC,
      balloonText: '<span style="font-size:14px">[[title]]<br><b>[[value]]</b> ([[percents]])</span>',
    });

    Chart.makeBarChart('webro2-widget-chart-2', {
      titles: [{
        text: 'Orders by Status',
      }],
      dataProvider: statusTotals,
      categoryField: 'label',
      graphs: [
        Chart.getBarGraph({
          balloonText: '[[label]]: <strong>[[count]]</strong><br>Current Total: <strong>$[[totalCost]]</strong><br>Estimated Total: <strong>$[[estimatedCost]]</strong>',
          valueAxis: 'VA1',
          valueField: 'count',
          fillColors: ['#03A9F4'],
        }),
      ],
      valueAxes: [{
        id: 'VA1',
        logarithmic: true,
        minMaxMultiplier: 0,
        treatZeroAs: 8,
        offset: 4,
        labelsEnabled: true,
      }],
    });
  }

  renderSummary() {
    const { averagePayTotal, lastLaborAverageDays, openAverageDays, totalCost, openROs } = this.state;

    return (
      <div style={{ marginLeft: '50px', marginRight: '50px' }}>
        <h4>Summary</h4>
      <Table
        bordered
      >
        <tbody>
        <tr>
          <td>Open Repair Orders</td>
          <td>{openROs}</td>
        </tr>
        <tr>
          <td>Average Days Since Last Labor</td>
          <td>{lastLaborAverageDays.toFixed(2).toLocaleString()}</td>
        </tr>
        <tr>
          <td>Average Days Open</td>
          <td>{openAverageDays.toFixed(2).toLocaleString()}</td>
        </tr>
        <tr>
          <td>Average Ticket Cost</td>
          <td>${averagePayTotal.toFixed(2).toLocaleString()}</td>
        </tr>
        <tr>
          <td>Customer Pay Total</td>
          <td>${totalCost.toLocaleString()}</td>
        </tr>
        </tbody>
      </Table>
      </div>
    );
  }

  render() {

    return (
      <ReportWidget
        pageName="WEBRO2"
        reportOptions={['BLAZELIST']}
        handleData={this.handleData}
      >
        <FlickityWidget>
          <div id="webro2-widget-chart-1" className="carousel-cell" />
          <div className="carousel-cell">{this.renderSummary()}</div>
          <div id="webro2-widget-chart-2" className="carousel-cell" />
        </FlickityWidget>

      </ReportWidget>
    );
  }
}

function mapStateToProps(state) {
  return {
    codes: state.app.codes,
  };
}

export default connect(mapStateToProps)(WEBRO2Widget);
